import RadioButton from '@/common/components/base/input/radioButton/RadioButton.tsx';
import { RadioGroupProps } from '@/common/components/base/input/radioGroup/RadioGroup.types.ts';
import Typography from '@/common/components/base/typography/Typography';
import React, { FC } from 'react';
import { Box, Flex } from 'styled-system/jsx';

const RadioGroup: FC<RadioGroupProps> = ({
  options,
  name,
  onChange,
  renderRadioButton,
  rules,
  title,
  className,
  wrapperClassName,
  disabled = false,
}) => {
  return (
    <Box className={wrapperClassName}>
      {title ? <Typography textStyle="b2">{title}</Typography> : null}
      <Flex mt="0.2rem" className={className}>
        {options.map((option) => (
          <React.Fragment key={option.value.toString()}>
            {renderRadioButton(
              <RadioButton
                typographyClassName=""
                rules={rules}
                disabled={disabled}
                name={name}
                label={option.label}
                onChange={onChange}
                value={option.value}
              />,
              option.value,
            )}
          </React.Fragment>
        ))}
      </Flex>
    </Box>
  );
};

export default RadioGroup;
